(() => {
  const trigger = document.querySelector('[data-angel-offer-trigger]');
  const offer = document.querySelector('[data-angel-offer]');
  if (!trigger || !offer) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const dismissalKey = 'angel-waist-offer-dismissed';
  const submissionKey = 'angel-waist-offer-submission-pending';
  const closeButtons = Array.from(offer.querySelectorAll('[data-angel-offer-close]'));
  const form = offer.querySelector('.angel-offer__form');
  const email = offer.querySelector('input[type="email"]');
  const successNotice = offer.querySelector('[data-angel-offer-success]');
  let frame;
  let lastFrame;
  let x = 0;
  let y = 0;
  let velocityX = 0.1274;
  let velocityY = 0.0936;
  let dismissed = false;
  let successTimer;
  let opener;
  let submitted = new URLSearchParams(window.location.search).get('customer_posted') === 'true';

  try {
    dismissed = window.sessionStorage.getItem(dismissalKey) === 'true';
    submitted = submitted || Boolean(window.sessionStorage.getItem(submissionKey) === 'true' && !offer.querySelector('.angel-offer__notice--error'));
  } catch (_) {}

  const stop = () => {
    if (frame) window.cancelAnimationFrame(frame);
    frame = undefined;
    lastFrame = undefined;
  };

  const position = () => {
    trigger.style.transform = `translate3d(${Math.round(x)}px, ${Math.round(y)}px, 0)`;
  };

  const bounds = () => ({
    maxX: Math.max(0, window.innerWidth - trigger.getBoundingClientRect().width),
    maxY: Math.max(0, window.innerHeight - trigger.getBoundingClientRect().height)
  });

  const seed = () => {
    const { maxX, maxY } = bounds();
    x = Math.min(maxX, window.innerWidth * 0.14);
    y = Math.min(maxY, window.innerHeight * 0.48);
    position();
  };

  const move = (time) => {
    if (dismissed || offer.classList.contains('is-open') || document.hidden || reducedMotion.matches) {
      frame = undefined;
      return;
    }
    if (!lastFrame) lastFrame = time;
    const elapsed = Math.min(40, time - lastFrame);
    lastFrame = time;
    const { maxX, maxY } = bounds();
    x += velocityX * elapsed;
    y += velocityY * elapsed;
    if (x <= 0 || x >= maxX) { x = Math.min(maxX, Math.max(0, x)); velocityX *= -1; }
    if (y <= 0 || y >= maxY) { y = Math.min(maxY, Math.max(0, y)); velocityY *= -1; }
    position();
    frame = window.requestAnimationFrame(move);
  };

  const start = () => {
    if (!dismissed && !offer.classList.contains('is-open') && !frame && !reducedMotion.matches) frame = window.requestAnimationFrame(move);
  };

  const setOpen = (isOpen, shouldFocus = true) => {
    if (successTimer && !isOpen) { window.clearTimeout(successTimer); successTimer = undefined; }
    stop();
    document.body.classList.toggle('angel-offer-open', isOpen);
    offer.classList.toggle('is-open', isOpen);
    offer.setAttribute('aria-hidden', String(!isOpen));
    if (isOpen) {
      opener = document.activeElement;
      if (shouldFocus) {
        window.setTimeout(() => {
          if (!offer.classList.contains('is-open')) return;
          if (typeof trapFocus === 'function') trapFocus(offer, email || offer);
          else email?.focus();
        }, 240);
      }
      return;
    }
    dismissed = true;
    document.body.classList.add('angel-offer-dismissed');
    try { window.sessionStorage.setItem(dismissalKey, 'true'); } catch (_) {}
    if (typeof removeTrapFocus === 'function') removeTrapFocus(shouldFocus && opener instanceof HTMLElement ? opener : null);
    else if (shouldFocus) opener?.focus?.();
  };

  const showSuccess = () => {
    offer.classList.add('is-success');
    if (successNotice) successNotice.hidden = false;
    setOpen(true, false);
    successTimer = window.setTimeout(() => setOpen(false, false), 2500);
  };

  trigger.addEventListener('click', () => setOpen(true));
  closeButtons.forEach((button) => button.addEventListener('click', () => setOpen(false)));
  form?.addEventListener('submit', () => {
    try { window.sessionStorage.setItem(submissionKey, 'true'); } catch (_) {}
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && offer.classList.contains('is-open')) setOpen(false); });
  window.addEventListener('resize', () => {
    const { maxX, maxY } = bounds();
    x = Math.min(maxX, Math.max(0, x));
    y = Math.min(maxY, Math.max(0, y));
    position();
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else start(); });
  reducedMotion.addEventListener?.('change', () => { stop(); if (!reducedMotion.matches) start(); });

  if (submitted && successNotice) {
    dismissed = false;
    document.body.classList.remove('angel-offer-dismissed');
    try { window.sessionStorage.removeItem(dismissalKey); window.sessionStorage.removeItem(submissionKey); } catch (_) {}
    showSuccess();
    const url = new URL(window.location.href);
    url.searchParams.delete('customer_posted');
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  } else if (dismissed) {
    document.body.classList.add('angel-offer-dismissed');
  } else if (offer.querySelector('[data-angel-offer-success]:not([hidden])')) {
    showSuccess();
  } else if (offer.querySelector('.angel-offer__notice--error')) {
    setOpen(true, false);
  } else {
    seed();
    start();
  }
})();
